import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useToast, usePopup, useStore, useGrid } from "@/comn/hooks";
import { APIS, SF_SPFC_CD_SRCH, SG_SPFC_CD_LST } from "./services/OsciComnPpupService";

export const APP_SPFC_CD_PPUP = (props: any) => {
    const pgeUid = "appSpfcCdPpup";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const { close, postMessage, getParams } = usePopup();
    const params = getParams();

    const form = {
        spfcCdSrch: useForm({
            defaultSchema: SF_SPFC_CD_SRCH,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        spfcCdLst: useGrid({
            defaultSchema: SG_SPFC_CD_LST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getSpfcCdLst: useFetch({
            api: (page = grid.spfcCdLst.page) => {
                const data = { ...form.spfcCdSrch.getValues(), adtnlItmCdNo: params.adtnlItmCdNo };
                return params.ofcrYn === "Y"
                    ? APIS.getOfcrSpfcCdList(data, page, grid.spfcCdLst.size)
                    : APIS.getSpfcCdList(data, page, grid.spfcCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.spfcCdSrch.errors) && form.spfcCdSrch.isSubmitted,
            key: [grid.spfcCdLst.page, grid.spfcCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.spfcCdSrch.getValues(),
                    page: grid.spfcCdLst.page,
                    size: grid.spfcCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.spfcCdSrch.handleSubmit(
                () => {
                    grid.spfcCdLst.setPage(0);
                    fetch.getSpfcCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_spfcCdLst: {
            cell: {
                spfcCd: (props: any) => {
                    const { rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={() => {
                                if (!comnUtils.isPopup()) return;
                                postMessage({ spfcCd: rowValues.spfcCd, spfcCdNm: rowValues.spfcCdNm });
                                close();
                            }}
                        >
                            {value}
                        </a>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
    }, []);

    return (
        <Page id={pgeUid} title={t("T_SPFC_CD_LST")}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.spfcCdSrch.schema.srchSpfcCd}></Group.Control>
                                <Group.Control {...form.spfcCdSrch.schema.srchSpfcCdNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    onClick={() => {
                                        form.spfcCdSrch.reset();
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.spfcCdLst.grid}
                            data={fetch.getSpfcCdLst.data?.spfcCdList}
                            render={render.grid_spfcCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
